<template>
    <aside class="files-box">
        <header
            class="files-box_header"
            @click="toggleCollapse"
        >
            <div class="w-100">
                <ProgressBar
                    v-if="progress"
                    :show="isCollapsed"
                    :percent="progress"
                />
            </div>
            <button class="btn">
                <i :class="`${isCollapsed ? 'fd-chevron-up' : 'fd-chevron-down'}`"></i>
            </button>
        </header>

        <section v-show="!isCollapsed">
            <ul class="w-100 files-box_list list list-unstyled">
                <FileItem
                    v-for="item in value"
                    :key="item.id"
                    tag="li"
                    :value="item"
                    class="item"
                />
            </ul>

            <div
                v-if="hasDone"
                class="text-right"
            >
                <button
                    class="btn"
                    @click="clear"
                >
                    {{ $t('clear') }}
                </button>
            </div>
        </section>
    </aside>
</template>

<script>
import ProgressBar from '@components/ProgressBar';
import FileItem from './FileItem.vue';

export default {
    name: 'FileLoaderBox',

    components: {
        ProgressBar,
        FileItem,
    },

    props: {
        value: {
            type: Array,
            required: true,
            validator(value) {
                // TODO: check each item
                return !!value;
            },
        },
    },

    data() {
        return {
            isCollapsed: false,
        };
    },

    computed: {
        progress() {
            if (this.value) {
                return (
                    this.value.filter((item) => !item.error).reduce((sum, a) => sum + a.progress, 0) / this.value.length
                );
            }

            return 0;
        },
        hasDone() {
            return this.value.some((item) => item.done || item.error);
        },
    },

    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        clear() {
            this.$store.commit('files/clear');
        },
    },
};
</script>

<style lang="scss" scoped>
.files-box {
    z-index: 9999999;
    min-width: 300px;
    background: $modal-content-bg;
    box-shadow: $box-shadow-lg;

    @include media-breakpoint-down(md) {
        max-width: 95vw;
    }

    &_header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: $modal-inner-padding;
    }

    &_list {
        padding: $modal-inner-padding;
        padding-top: 0;
        margin-bottom: 0;
    }

    .item {
        word-bottom: break-all;
        padding-right: 1rem;
        margin-bottom: 1rem;

        &:last-of-type {
            margin-bottom: 0;
        }
    }
}
</style>
